import React, { useState } from 'react';
import { RotateLoader } from 'react-spinners';
import { ValidationError } from 'yup';

import { DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { UserListInterface } from '../types';
import { setPasswordQuickAction } from '../usersApi';
import { validationSchema } from '../resetPasswordSchema';
import { useNotify } from '../../Common/snackbarHooks';
import { commonStyles, css } from '../../Common/styling';

type Props = {
  user: UserListInterface | undefined;
  setModalState: (modalState: boolean) => void;
};

const SetPasswordModal: React.FC<Props> = (props) => {
  const { notifyError, notifySuccess } = useNotify();
  const [loading, setLoading] = useState(false);
  const [newValue, setNewValue] = useState('');
  let passwordError = '';
  if (newValue.length > 0) {
    try {
      validationSchema.validateSyncAt('password', { password: newValue, confirm_password: newValue });
    } catch (error) {
      if (error instanceof ValidationError) passwordError = error.message;
      else throw error;
    }
  }

  const handleSubmit = (): void => {
    setLoading(true);
    if (props.user) {
      setPasswordQuickAction(props.user.id, newValue)
        .then(() => {
          notifySuccess('Lösenord uppdaterat');
        })
        .catch(() =>
          notifyError(
            'Det gick inte att uppdatera lösenordet. Lösenord ska vara mellan 8 och 20 tecken långt och innehålla stora och små bokstäver, siffror och specialtecken.'
          )
        )
        .finally(() => {
          setLoading(false);
          props.setModalState(false);
        });
    }
  };

  return (
    <div>
      <DialogTitle>Sätt nytt lösenord för {props.user?.name}</DialogTitle>
      {loading ? (
        <div style={{ minHeight: '120px' }}>
          <DialogContent>
            <div className={css(commonStyles.spinner)}>
              <RotateLoader loading={loading} />
            </div>
          </DialogContent>
        </div>
      ) : (
        <React.Fragment>
          <DialogContent style={{ padding: '20px' }}>
            <TextField
              error={Boolean(passwordError)}
              helperText={
                passwordError ||
                'Lösenordet måste vara mellan 8 och 20 tecken långt och innehålla minst en versal (A–Z), en gemen (a–z), en siffra (0–9) och ett specialtecken.'
              }
              fullWidth
              disabled={false}
              name={'new_password'}
              label={'Nytt lösenord för användaren'}
              placeholder={'Skriv nytt lösenord'}
              variant="outlined"
              onChange={(value) => {
                setNewValue(value.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              color="error"
              variant="contained"
              onClick={(): void => {
                props.setModalState(false);
              }}
            >
              AVBRYT
            </Button>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={(): void => {
                handleSubmit();
              }}
            >
              SPARA
            </Button>
          </DialogActions>
        </React.Fragment>
      )}
    </div>
  );
};

export default SetPasswordModal;
